import { buildDeadlineGoalListTree } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useMemo } from 'react';
import { TreeItem } from 'shared/components/ui/virtualized-tree-list';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export type Options = {
  hideArchived?: boolean;
  hideCompleted?: boolean;
  goalChildrenByParentId?: Map<ID, ID[]>;
  nestSubGoals?: boolean;
};

export const useDeadlineGoalListTree = (
  goals: Goal[],
  {
    hideArchived,
    hideCompleted,
    goalChildrenByParentId,
    nestSubGoals,
  }: Options,
) => {
  const allGoals = useSortedGoals();
  const links = useEntityLinks();

  return useMemo<Record<ID, TreeItem>>(
    () =>
      buildDeadlineGoalListTree(goals, {
        hideArchived,
        hideCompleted,
        allGoals,
        links,
        goalChildrenByParentId,
        nestSubGoals,
      }),
    [
      goals,
      allGoals,
      links,
      hideArchived,
      hideCompleted,
      goalChildrenByParentId,
      nestSubGoals,
    ],
  );
};
